/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section6_P1Inputs */

const en_privacy_section6_p1 = /** @type {(inputs: Privacy_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date. Since PureJSON does not collect user data, policy changes will typically relate to third-party services.`)
};

const ko_privacy_section6_p1 = /** @type {(inputs: Privacy_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 개인정보처리방침은 수시로 업데이트될 수 있습니다. 변경 사항은 업데이트된 날짜와 함께 이 페이지에 게시됩니다. PureJSON은 사용자 데이터를 수집하지 않으므로 정책 변경은 일반적으로 제3자 서비스와 관련됩니다.`)
};

const ja_privacy_section6_p1 = /** @type {(inputs: Privacy_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプライバシーポリシーは随時更新される場合があります。変更はこのページに更新日とともに掲載されます。PureJSONはユーザーデータを収集しないため、ポリシーの変更は通常サードパーティサービスに関連するものです。`)
};

/**
* | output |
* | --- |
* | "We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date. Since PureJSON does not collect u..." |
*
* @param {Privacy_Section6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section6_p1 = /** @type {((inputs?: Privacy_Section6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section6_p1(inputs)
	if (locale === "ko") return ko_privacy_section6_p1(inputs)
	return ja_privacy_section6_p1(inputs)
});